<script setup>
import { useRouter, useRoute } from 'vue-router';

import Button from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const router = useRouter();
const route = useRoute();

const navigateToMfa = () => {
  router.push({
    name: 'profile_settings_mfa',
    params: {
      accountId: route.params.accountId,
    },
  });
};
</script>

<!-- Phase 9.5: the 2FA state and its action as one setting row; the page profile_settings_mfa stays its own route. -->
<template>
  <div class="flex flex-wrap items-center justify-between gap-4">
    <div class="grid min-w-0 flex-1 basis-56 gap-0.5">
      <p class="flex items-center gap-2 type-polaris-label">
        <Icon
          icon="i-lucide-lock-keyhole"
          class="size-4 shrink-0 text-polaris-muted-foreground"
        />
        {{ $t('MFA_SETTINGS.TITLE') }}
      </p>
      <p class="type-polaris-body text-polaris-muted-foreground">
        {{ $t('MFA_SETTINGS.DESCRIPTION') }}
      </p>
    </div>
    <Button
      type="button"
      outline
      slate
      sm
      :label="$t('PROFILE_SETTINGS.FORM.SECURITY_SECTION.MFA_BUTTON')"
      icon="i-lucide-settings"
      class="shrink-0"
      @click="navigateToMfa"
    />
  </div>
</template>
